import yup from '~/utils/validationMessages'

export const validationSchema = yup.object().shape({
  email: yup.string().email().required(),
})
